import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'Firebase',
  initialState: { deviceId: '', fcmToken: '' },
  reducers: {
    setFcmToken: (state, action) => {
      state.fcmToken = action.payload
    },
    setDeviceId: (state, action) => {
      state.deviceId = action.payload
    }
  }
})

export const {
  actions: { setFcmToken, setDeviceId },
  reducer: firebaseReducer
} = slice
